// Brazilian CPF (Cadastro de Pessoas Físicas) check-digit validation.
// Mod-11 algorithm. Strips non-digits, requires 11 digits, rejects
// repeated-digit patterns (00000000000, 11111111111, ...).
//
// IMPORTANT: keep logic identical to the inline implementation in
// supabase/functions/asaas-create-subscription/index.ts (`isValidCpf`).
// Edge function does not import npm modules, so the algorithm is duplicated
// rather than shared. Any change here must be mirrored there.

export function isValidCpf(raw: unknown): boolean {
  if (typeof raw !== "string") return false;
  const d = raw.replace(/\D/g, "");
  if (d.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(d)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(d.charAt(i), 10) * (10 - i);
  let v1 = 11 - (sum % 11);
  if (v1 >= 10) v1 = 0;
  if (v1 !== parseInt(d.charAt(9), 10)) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(d.charAt(i), 10) * (11 - i);
  let v2 = 11 - (sum % 11);
  if (v2 >= 10) v2 = 0;
  return v2 === parseInt(d.charAt(10), 10);
}

// Format raw digits into 000.000.000-00. Truncates after 11 digits.
export function formatCpf(raw: string): string {
  const d = raw.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return d.slice(0, 3) + "." + d.slice(3);
  if (d.length <= 9) return d.slice(0, 3) + "." + d.slice(3, 6) + "." + d.slice(6);
  return d.slice(0, 3) + "." + d.slice(3, 6) + "." + d.slice(6, 9) + "-" + d.slice(9);
}

// Format raw digits into +55 (00) 00000-0000 (or 0000-0000 for 10-digit).
// Empty string for empty input.
export function formatPhoneBR(raw: string): string {
  const d = raw.replace(/\D/g, "").slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return "+55 (" + d;
  if (d.length <= 6) return "+55 (" + d.slice(0, 2) + ") " + d.slice(2);
  if (d.length <= 10) return "+55 (" + d.slice(0, 2) + ") " + d.slice(2, 6) + "-" + d.slice(6);
  return "+55 (" + d.slice(0, 2) + ") " + d.slice(2, 7) + "-" + d.slice(7);
}
